import { queryOptions } from '@tanstack/react-query';
import API from '@/api';
import { queryKeys } from '@/api/utils/queryKeys';

export const ukBankAccountQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.UK.bankAccount,
    queryFn: API.UK.paymentProvider.getBankAccount,
  });
